import React from 'react';
import { useFormContext } from '../FormContext';
import FormConfigOptions from './FormConfigOptions';
import FormConfigRequired from './FormConfigRequired';
import FormConfigTitleDescription from './FormConfigTitleDescription';
export const FormConfigRadioGroup = () => {
    const { formState } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(FormConfigOptions, null)));
};
export default FormConfigRadioGroup;
//# sourceMappingURL=FormConfigRadioGroup.js.map